"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = function (val) {
    return typeof val === "function";
};
exports.isNumber = function (val) {
    return typeof val === "number";
};
exports.isNumberLike = function (val) {
    return exports.isNumber(val) ? true : exports.isString(val) ? val.length > 0 && !isNaN(val) : false;
};
exports.isString = function (val) {
    return typeof val === "string";
};
exports.isNull = function (val) {
    return val === null;
};
exports.isUndefined = function (val) {
    return val === undefined;
};
exports.isObject = function (val) {
    return !exports.isNull(val) && typeof val === "object";
};
exports.isPlainObject = function (val) {
    return exports.isObject(val) && !exports.isArray(val) && !exports.isFunction(val);
};
exports.isArray = function (arr) {
    return Array.isArray(arr);
};
exports.isNode = function (val) {
    return typeof Node === "object"
        ? val instanceof Node
        : val && typeof val === "object" && typeof val.nodeType === "number" && typeof val.nodeName === "string";
};
exports.isElement = function (val) {
    return typeof HTMLElement === "object"
        ? val instanceof HTMLElement
        : val && typeof val === "object" && val !== null && val.nodeType === 1 && typeof val.nodeName === "string";
};
exports.randomInt = function (min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 9999; }
    return Math.floor(Math.random() * (max - min)) + min;
};
exports.randomDec = function (min, max, decimals) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 9999; }
    if (decimals === void 0) { decimals = 2; }
    return (Math.random() * (max - min) + min).toFixed(decimals);
};
exports.randomList = function (list) {
    return list[exports.randomInt(0, list.length)];
};
exports.exec = function (fn) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return exports.isFunction(fn)
        ? fn.apply(_this, args)
        : undefined;
};
exports.mapRange = function (value, source, target) {
    return target[0] + (value - source[0]) * (target[1] - target[0]) / (source[1] - source[0]);
};
exports.cleanString = function () {
    var x = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        x[_i] = arguments[_i];
    }
    return x
        .filter(function (x) { return typeof x === "string"; })
        .map(function (x) { return x.trim(); })
        .join(" ");
};
exports.pause = function (ms) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                var timeout = setTimeout(resolve, ms);
                return function () {
                    clearTimeout(timeout);
                    reject("pause canceled");
                };
            })];
    });
}); };
exports.UUID = function () {
    var d = Date.now();
    if (window.performance && typeof window.performance.now === "function")
        d += performance.now();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === "x" ? r : (r & 0x3 | 0x8)).toString(16);
    });
};
exports.pad = function (num, padlen, padchar) {
    if (padchar === void 0) { padchar = "0"; }
    var pad = new Array(1 + padlen).join(padchar);
    return (pad + num).slice(-pad.length);
};
exports.msToS = function (ms) {
    return ms / 1000;
};
exports.sToMs = function (s) {
    return s * 1000;
};
exports.mToS = function (m) {
    return m * 60;
};
exports.sToM = function (s) {
    return s / 60;
};
exports.mToMs = function (m) {
    return exports.sToMs(exports.mToS(m));
};
exports.msToM = function (ms) {
    return exports.sToM(exports.msToS(ms));
};
exports.mmToPx = function (mm, dpi) {
    if (dpi === void 0) { dpi = 200; }
    return (mm * dpi) / 25.4;
};
exports.pxToMm = function (px, dpi) {
    if (dpi === void 0) { dpi = 200; }
    return (px / dpi) * 25.4;
};
exports.getDpi = function (px, mm) {
    return px / mm * 25.4;
};
exports.isMobile = function () {
    return window.innerWidth < 768;
};
exports.stingifyTime = function (ms, withMs) {
    var m = Math.floor(exports.msToM(ms));
    ms -= exports.mToMs(m);
    var s = withMs ? Math.floor(exports.msToS(ms)) : Math.round(exports.msToS(ms));
    ms -= exports.sToMs(s);
    return exports.pad(m, 2) + ":" + exports.pad(s, 2) + (withMs ? ":" + exports.pad(Math.floor(ms), 3) : "");
};
exports.parseTime = function (duration) {
    var d = duration.split(":");
    return exports.mToMs(parseInt(d[0], 10)) + exports.sToMs(parseInt(d[1], 10)) + parseInt(d[2], 10);
};
exports.uniqueArray = function (arr) {
    return Array.from(new Set(arr));
};
exports.generateHashFromString = function (str) {
    return str.split("").reduce(function (prevHash, currVal) { return (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0; }, 0);
};
exports.findKey = function (obj, cb) {
    for (var k in obj)
        if (cb(obj[k], k, obj))
            return k;
    return undefined;
};
exports.findObj = function (obj, cb) {
    var key = exports.findKey(obj, cb);
    if (key === undefined)
        return undefined;
    return obj[key];
};
exports.filterObj = function (obj, cb) {
    var result = {};
    for (var k in obj)
        if (cb(obj[k], k, obj))
            result[k] = obj[k];
    return result;
};
exports.reduceObj = function (obj, cb, result) {
    for (var k in obj)
        result = cb(result, obj[k], k, obj);
    return result;
};
exports.mapObj = function (obj, cb) {
    var result = {};
    for (var k in obj)
        result[k] = cb(obj[k], k, obj);
    return result;
};
exports.groupObj = function (obj, key) {
    var result = {};
    for (var k in obj) {
        var gr = obj[k][key];
        if (result[gr] === undefined)
            result[gr] = [];
        result[gr].push(__assign({ $key: k }, obj[k]));
    }
    return result;
};
exports.group = function (arr, key) {
    var result = {};
    for (var i = 0; i < arr.length; i++) {
        var gr = arr[i][key];
        if (result[gr] === undefined)
            result[gr] = [];
        result[gr].push(arr[i]);
    }
    return result;
};
exports.repeat = function (times, cb) {
    for (var i = 0; i < times; i++)
        cb(i);
};
exports.repeatMap = function (times, fn) {
    var result = [];
    for (var i = 0; i < times; i++)
        result[i] = fn(i);
    return result;
};
exports.objectToArray = function (obj, key) {
    if (key === void 0) { key = "$key"; }
    return exports.reduceObj(obj, function (r, x, k) {
        var _a;
        return r.concat(__assign(__assign({}, x), (_a = {}, _a[key] = k, _a)));
    }, []);
};
exports.arrayToObject = function (arr, key) {
    if (key === void 0) { key = "$key"; }
    return arr.reduce(function (r, x) {
        var copy = __assign({}, x);
        delete copy[key];
        r[x[key]] = copy;
        return r;
    }, {});
};
exports.increment = function () {
    var i = 0;
    return function () { return i++; };
};
exports.diff = function (cb) {
    var x = cb();
    return function () { return cb() - x; };
};
exports.debounce = function (fn, threshold) {
    if (threshold === void 0) { threshold = 100; }
    var t;
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(t);
        t = setTimeout(function () { return fn.apply(void 0, args); }, threshold);
    });
};
exports.throttle = function (fn, threshold) {
    if (threshold === void 0) { threshold = 100; }
    var p;
    var t;
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        clearTimeout(t);
        var now = Date.now();
        if (!p || now - p >= threshold) {
            p = now;
            fn.apply(void 0, args);
        }
        else {
            t = setTimeout(function () { return fn.apply(void 0, args); }, threshold);
        }
    });
};
exports.partial = function (fn) {
    var argsBound = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        argsBound[_i - 1] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.call.apply(fn, __spreadArrays([_this], argsBound, args));
    };
};
exports.partialRight = function (fn) {
    var argsBound = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        argsBound[_i - 1] = arguments[_i];
    }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fn.call.apply(fn, __spreadArrays([_this], args, argsBound));
    };
};
exports.curry = function (fn) { return function curried() {
    var _this = this;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args.length >= fn.length)
        return fn.call.apply(fn, __spreadArrays([this], args));
    else
        return function () {
            var args2 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args2[_i] = arguments[_i];
            }
            return curried.call.apply(curried, __spreadArrays([_this], args, args2));
        };
}; };
exports.createMap = function () { return ({
    store: {},
    get: function (uuid) {
        return this.store[uuid];
    },
    set: function (uuid, base64) {
        this.store[uuid] = base64;
    }
}); };
exports.createToggle = function () { return ({
    value: false,
    on: function () { this.value = true; },
    off: function () { this.value = false; },
    toggle: function () { this.value = !this.value; }
}); };
exports.removeIfExists = function (arr, value) {
    var i = arr.indexOf(value);
    if (i !== -1)
        arr.splice(i, 1);
    return arr;
};
exports.memoize = function (fn, hashFn) {
    if (hashFn === void 0) { hashFn = function (args) { return JSON.stringify(args); }; }
    var cache = {};
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var hash = hashFn(args);
        if (!cache[hash])
            cache[hash] = fn.apply(void 0, args);
        return cache[hash];
    });
};
exports.memoizeFixParams = function (fixParams, memoized) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return memoized.apply(void 0, fixParams.apply(void 0, args));
    });
};
exports.filterFnUnique = function (keys) {
    return (function (x, i, a) {
        return a.findIndex(function (y) {
            return keys.every(function (k) { return y[k] === x[k]; });
        }) === i;
    });
};
exports.matchesProperties = exports.memoize(function (a, b, keys) {
    return (!a || !b)
        ? false
        : keys.every(function (x) {
            return a[x] === b[x];
        });
});
exports.clone = function (obj) {
    return JSON.parse(JSON.stringify(obj));
};
exports.freeze = function (obj) {
    if (Object.isFrozen(obj))
        return obj;
    if (!Array.isArray(obj) && Object.getPrototypeOf(obj) !== Object.getPrototypeOf({}))
        return obj;
    Object.freeze(obj);
    Object.keys(obj)
        .forEach(function (x) { return exports.freeze(obj[x]); });
    return obj;
};
exports.formatSize = function (bytes) {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes == 0)
        return "0 Byte";
    var i = Math.floor(Math.floor(Math.log(bytes) / Math.log(1024)));
    var size = (bytes / Math.pow(1024, i));
    size = Math.round(size * 100) / 100;
    return size + sizes[i];
};
exports.getRatio = function (dimensions) {
    return dimensions.width / dimensions.height;
};
exports.formatPrice = function (price, decimal) {
    price = (Math.round(price * 100) / 100);
    var part = (price + "").split(".");
    return "&euro;&nbsp;" + part[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".") + (decimal ? ("," + (part[1] === undefined ? "00" : (part[1].length < 2 ? part[1] + "0" : part[1]))) : "");
};
exports.isIE = exports.memoize(function () {
    return (/MSIE (\d+\.\d+);/.test(navigator.userAgent) || navigator.userAgent.indexOf("Trident/") > -1);
}, function () { return navigator.userAgent; });
exports.copyToClipboard = function (str) {
    try {
        var el = document.createElement("textarea");
        el.value = str;
        el.setAttribute("readonly", "");
        el.style.position = "absolute";
        el.style.left = "-9999px";
        document.body.appendChild(el);
        var selection = document.getSelection();
        var selected = selection && selection.rangeCount > 0 ? selection.getRangeAt(0) : false;
        el.select();
        selection = document.getSelection();
        document.execCommand("copy");
        document.body.removeChild(el);
        if (selected) {
            selection.removeAllRanges();
            selection.addRange(selected);
        }
        return true;
    }
    catch (err) {
        return false;
    }
};
exports.createCanvas = function (dimensions) {
    var canvas = document.createElement("canvas");
    canvas.width = dimensions.width;
    canvas.height = dimensions.height;
    var ctx = canvas.getContext("2d");
    return { canvas: canvas, ctx: ctx };
};
exports.createImage = function (src) {
    return new Promise(function (res, rej) {
        var img = new Image();
        img.crossOrigin = "Anonymous";
        img.onload = function () { return res(img); };
        img.onerror = function (err) { return rej(err); };
        img.src = src;
    });
};
exports.crop = function (image, crop) {
    var _a = exports.createCanvas(crop), canvas = _a.canvas, ctx = _a.ctx;
    ctx.drawImage(image, crop.x, crop.y, crop.width, crop.height, 0, 0, crop.width, crop.height);
    return canvas;
};
exports.getImageTypeFromB64 = function (source) {
    var match = source.match(/(image\/.*)?;/);
    return (match && match[1]) ? match[1] : "image/png";
};
exports.base64toBlob = function (src) {
    var base64Data = src.replace(/^data:image\/(.*?);base64,/, "");
    var contentType = exports.getImageTypeFromB64(src);
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);
    for (var i = 0; i < slicesCount; ++i) {
        var begin = i * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);
        var bytes = new Array(end - begin);
        for (var offset = begin, i_1 = 0; offset < end; ++i_1, ++offset)
            bytes[i_1] = byteCharacters[offset].charCodeAt(0);
        byteArrays[i] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
};
exports.fileToB64 = function (file) {
    return new Promise(function (res, rej) {
        var reader = new FileReader();
        reader.onload = function () { return res(reader.result); };
        reader.onerror = function (err) { return rej(err); };
        reader.readAsDataURL(file);
    });
};
exports.imageUrlToB64 = function (url) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
            if (xhr.response.type.indexOf("image") === -1)
                return reject(xhr.response.type + " is not an image");
            var reader = new FileReader();
            reader.onloadend = function () { return resolve(reader.result); };
            reader.readAsDataURL(xhr.response);
        };
        xhr.onerror = reject;
        xhr.onabort = reject;
        xhr.ontimeout = reject;
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
    });
};
// export const colorPicker = (canvas: HTMLCanvasElement, onhover: (...number) => void, onclick: (...number) => void) => {
//   const ctx = canvas.getContext("2d")
//   if (!ctx) {
//     throw new Error("canvas not initialized")
//   }
//   const pick = (event): number[] => {
//     const x = event.layerX
//     const y = event.layerY
//     const pixel = ctx.getImageData(x, y, 1, 1)
//     const data = pixel.data
//     return [data[0], data[1], data[2], data[3]]
//   }
//   canvas.addEventListener("mousemove", (event) => onhover(...pick(event)))
//   canvas.addEventListener("click", (event) => onclick(...pick(event)))
// }
